import ApiFetcher2 from '../ApiFetcher2';

const DISTRICT_CONFIGURATION_URL = 'district-configuration/';

class DistrictConfigurationApi {
  static get() {
    return ApiFetcher2.get(DISTRICT_CONFIGURATION_URL);
  }
}

export default DistrictConfigurationApi;
